// translation dictionaries
export { deDict } from './de';
export { enDict } from './en';
export { esDict } from './es';
export { frDict } from './fr';
export { itDict } from './it';
export { jaDict } from './ja';
export { krDict } from './kr';
export { nlDict } from './nl';
export { plDict } from './pl';
export { ptDict } from './pt';
export { zhDict } from './zh';

// default text phrases
export { defaultTexts } from './defaultTexts';
